import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import UnityDiagram from "../../assets/img/UnityDiagram.png";

export default function WorkingTogether() {
  return (
    <Wrapper id="working">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">How can we work toghether?</h1>
            <p className="font13">
              Unity is in diversity. There is a notion that due to our diverse
              nature it is difficult to work toghether. Nothing can be far from
              the truth. We are united already, we are just not organized. Due
              to the our life style and demography, Hindus are living like a
              detached islands. What we need to do is connect all of us in a
              collaborative way. ISRHB intend to address this issue using four
              principles.
              <br />
              <ul>
                <li>
                  <b>Communicate: </b>
                  Let's share news, success stories, and good practices of
                  fellow Hindu brothers and sisters. This will let the othes
                  know that they are not alone and a point of communication will
                  be established.{" "}
                </li>
                <li>
                  <b>Collborate: </b> Let's support each other's activites and
                  events. This can be Puja, birthday party, or any endeavour.
                </li>
                <li>
                  <b>Celebrate: </b> Let's be appreciative of each others
                  success and achievements.
                </li>
                <li>
                  <b>Congregate Preservation: </b> Let's meet more often both
                  virtually and personally. This will create trust and bond
                  among us.
                </li>
              </ul>
            </p>
            <div>
              <img
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "40%",
                }}
                src={UnityDiagram}
              />
            </div>
          </HeaderInfo>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto;
  }
`;
